<mat-sidenav-container class="sidenav-container" autosize>
    <mat-sidenav #sidenav class="sidenav" mode="side" [opened]="hoveringLeftEdge">
      <div class="logo-section">
        <img src="assets/ulaap_logo.png" alt="Logo" class="logo">
      </div>
      <mat-nav-list>
        <ng-container *ngFor="let menuItem of menuData$ | async">
          <h3 mat-subheader class="menu-header" *ngIf="!(menuStateService.sidenavState$ | async)?.opened">{{menuItem.ams_side_menu_text}}</h3>
          <ng-container *ngFor="let subMenuItem of menuItem.ams_side_sub_menu">
            <a
              mat-list-item
              *ngIf="subMenuItem.ams_side_sub_menu_page; else subMenuHeading"
              [routerLink]="'/' + subMenuItem.ams_side_sub_menu_page"
              routerLinkActive="active-link"
            >
              <i class="menu-item-icon {{subMenuItem.ams_side_sub_menu_icon || 'fa-solid fa-circle-dot'}}" [class.icon-only]="(menuStateService.sidenavState$ | async)?.opened"></i>
              <span class="menu-item-text" [class.icon-only]="(menuStateService.sidenavState$ | async)?.opened">{{subMenuItem.ams_side_sub_menu_text}}</span>
            </a>

            <ng-template #subMenuHeading>
              <div class="menu-parent-item">
                <i class="menu-item-icon {{subMenuItem.ams_side_sub_menu_icon || 'fa-solid fa-folder'}}" [class.icon-only]="(menuStateService.sidenavState$ | async)?.opened"></i>
                <span class="menu-item-text" [class.icon-only]="(menuStateService.sidenavState$ | async)?.opened">{{subMenuItem.ams_side_sub_menu_text}}</span>
              </div>
            </ng-template>

            <div class="submenu-child-list" *ngIf="subMenuItem.ams_side_sub_sub_menu?.length">
              <a
                mat-list-item
                class="submenu-child-link"
                *ngFor="let subSubMenuItem of subMenuItem.ams_side_sub_sub_menu"
                [routerLink]="'/' + subSubMenuItem.ams_side_sub_sub_menu_page"
                routerLinkActive="active-link"
              >
                <i class="menu-item-icon {{subSubMenuItem.ams_side_sub_sub_menu_icon || 'fa-solid fa-circle-dot'}}" [class.icon-only]="(menuStateService.sidenavState$ | async)?.opened"></i>
                <span class="menu-item-text" [class.icon-only]="(menuStateService.sidenavState$ | async)?.opened">{{subSubMenuItem.ams_side_sub_sub_menu_text}}</span>
              </a>
            </div>
          </ng-container>
        </ng-container>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content>
      <mat-toolbar color="primary">
        <mat-toolbar-row>
          <span class="toolbar-title">AMS</span>

          <span class="spacer"></span>

          <button mat-button [matMenuTriggerFor]="profileMenu">
            <mat-icon>account_circle</mat-icon>
            <span>{{ userEmail }}</span>
          </button>

          <mat-menu #profileMenu="matMenu">
            <button mat-menu-item (click)="toggleTheme()">
              <mat-icon>brightness_6</mat-icon>
              <span>Toggle Theme</span>
            </button>
            <button mat-menu-item [routerLink]="['/site_updates']">
              <mat-icon>newspaper</mat-icon>
              <span>Site Updates</span>
            </button>
            <button mat-menu-item (click)="signOut()">
              <mat-icon>logout</mat-icon>
              <span>Sign Out</span>
            </button>
          </mat-menu>
        </mat-toolbar-row>
      </mat-toolbar>
      <div class="ams-content"><ng-content></ng-content> </div>
    </mat-sidenav-content>
</mat-sidenav-container>
